// AD-2701: the words in the saved reports list on the Reports page.

const parse = (text) => {
    try {
        return JSON.parse(text || '{}') ?? {};
    } catch {
        return {};
    }
};

const joinNames = (names) => (names.length <= 1
    ? names.join('')
    : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`);

// "Student report: ON-ROLL - Year 9, excluding ON-ROLL - Dietary Needs - Halal, plus 2 chosen by name"
export const aboutSavedReport = (report) => {
    const saved = parse(report.settings);
    const settings = saved.settings ?? {};
    const groups = settings.groupFilters ?? [];
    const included = groups.filter(group => !group.excluded).map(group => group.displayName);
    const excluded = groups.filter(group => group.excluded).map(group => group.displayName);
    const byName = ['studentFilters', 'applicationFilters', 'enquiryFilters', 'employeeFilters']
        .reduce((count, key) => count + (settings[key]?.length ?? 0), 0);

    const parts = [];
    if (included.length) {
        parts.push(joinNames(included) + (included.length > 1 && saved.strictRecipientsFiltering ? ' (in all of them)' : ''));
    }
    if (excluded.length) parts.push(`excluding ${joinNames(excluded)}`);
    if (byName) parts.push(`${included.length ? 'plus ' : ''}${byName} chosen by name`);

    const kind = report.memberType === 'employee' ? 'Employee report' : 'Student report';
    return parts.length ? `${kind}: ${parts.join(', ')}` : kind;
};

// Maria, 15 October 2026: a report is saved for the person alone, or for anyone with permission to view it.
export const availableTo = (report) => (report.sharedWith === 'me'
    ? `Only ${report.createdByName}`
    : 'Anyone with permission');

export const lastRun = (report) => {
    if (!report.lastRunAt) return 'Not run yet';
    const date = new Date(report.lastRunAt).toLocaleDateString('en-GB');
    return report.lastRunByName ? `${date} by ${report.lastRunByName}` : date;
};
